import { render, staticRenderFns } from "./deliveryGuidelines.vue?vue&type=template&id=53051f0c&scoped=true&"
import script from "./deliveryGuidelines.vue?vue&type=script&lang=js&"
export * from "./deliveryGuidelines.vue?vue&type=script&lang=js&"
import style0 from "./deliveryGuidelines.vue?vue&type=style&index=0&id=53051f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53051f0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
